import {PRODUCT_PARAMETER_BLACKLIST} from "constants/ProductConstants";
import isEmpty from "lodash/isEmpty";
import {indexOf} from "lodash";


const ParametersTable = ({parameters}) => {
    const selectedParameters = parameters
        .filter((parameterRelation) => {
            return indexOf(PRODUCT_PARAMETER_BLACKLIST, parameterRelation.hash) === -1
        })
        .reduce((carry, param) => {
            const key = param.name;
            (carry[key] = carry[key] || []).push(param);
            return carry;
        }, {});


    if (isEmpty(selectedParameters)) {
        return '';
    }

    return (
        <div className="tables">
            <table>
                <tbody>
                {Object.keys(selectedParameters).map(
                    (key, index) => {
                        return (
                            <tr
                                key={`product-parameters-${index}`}
                            >
                                <th>{key}</th>
                                <td>{selectedParameters[key].map(p => p.value).join(', ')}</td>
                            </tr>
                        );
                    }
                )}
                </tbody>
            </table>
        </div>
    );
};

export default ParametersTable;
